module.exports = __webpack_public_path__ + "01_short_yellow.6436cd04.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/01_short_yellow.png
// module id = VMA+
// module chunks = 0